import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { useNavigate } from "react-router-dom";

import Header from "components/Header/Header";
import NotFoundGraphic from "components/NotFoundGraphic";


export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="NotFound">
      <Header /> 
      <Container className="d-flex align-items-center align-items-lg-end justify-content-center" style={{minHeight: "98vh", position: "relative"}}>
        <div className="p-2 d-block d-lg-none" style={{backgroundColor: "#F7F9FF"}}>
          <NotFoundGraphic mobileView={true} className="responsive-not-found-graphic pt-4" />
          <h2 className="pb-4 fw-semibold">Page not found.</h2>
          <p>The page you&apos;re trying to find doesn&apos;t exist or has changed.</p>
          <p>Here are some links you might find helpful:</p>
          <ul>
            <li className="pb-1" onClick={() => navigate(-1)} style={{color: "#0000EE", cursor: "pointer", textDecoration: "underline"}}>Back to Previous Page</li>
            <li className="py-1" onClick={() => navigate("/")} style={{color: "#0000EE", cursor: "pointer", textDecoration: "underline"}}>Back to Main Page</li>
            <li className="py-1" onClick={() => navigate("/settings")} style={{color: "#0000EE", cursor: "pointer", textDecoration: "underline"}}>Settings Page</li>
          </ul>
        </div>
        <div className="d-none d-lg-block mt-5">
          <Row className="d-flex">
            <Col xs={12}>
              <div style={{position: "relative"}}>
                <NotFoundGraphic className="responsive-not-found-graphic" />
                <div className="p-2 responsive-not-found-text" style={{position: "absolute", top: "0px", left: "50%", backgroundColor: "#F7F9FF"}}>
                  <h2 className="responsive-not-found-header pb-4 fw-semibold">Page not found.</h2>
                  <p>The page you&apos;re trying to find doesn&apos;t exist or has changed.</p>
                  <p>Here are some links you might find helpful:</p>
                  <ul>
                    <li className="pb-1" onClick={() => navigate(-1)} style={{color: "#0000EE", cursor: "pointer", textDecoration: "underline"}}>Back to Previous Page</li>
                    <li className="py-1" onClick={() => navigate("/")} style={{color: "#0000EE", cursor: "pointer", textDecoration: "underline"}}>Back to Main Page</li>
                    <li className="py-1" onClick={() => navigate("/settings")} style={{color: "#0000EE", cursor: "pointer", textDecoration: "underline"}}>Settings Page</li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}
